export default __webpack_public_path__ + "static/media/learn_more_page_2.6d1526e8.jpg";